import React from "react";
import { connect } from "react-redux";
import { Formik } from "formik";

import { FormCollapsible, Select, SubmitButton, TextInput } from "components/forms";
import { activeFunderIdSelector, managementChoicesSelector, shouldSaveSelector } from "reducers";
import { Form } from "react-bootstrap";
import { isAdmin } from "permissions";
import * as notifications from "../../notifications";
import * as Yup from "yup";
import WSelect from "../../components/forms/selects/WindowedSelect";
import { createFunderContactAffiliation, fetchFunderContactAffiliationsFromFunder } from "../../actions";

const BasicCreateContactAffiliationForm = ({ ...props }) => {
  const validationSchema = Yup.object().shape({
    funder_contact: Yup.number().required(),
    funder: Yup.number().required(),
  });
  return (
    <Formik
      enableReinitialize
      initialValues={{
        funder: props.activeFunderId,
      }}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        try {
          await props.createFunderContactAffiliation({
            funder: values?.funder,
            funder_contact: values?.funder_contact,
          });
          props.fetchFunderContactAffiliationsFromFunder(props.activeFunderId);
        } catch (error) {
          setErrors(error.response.data);
          notifications.error("Error creating Funder Contact Affiliation");
        }
        props.unsetShouldSave();
        setSubmitting(false);
      }}
    >
      {({ handleSubmit, values }) => {
        return (
          <FormCollapsible onSubmit={handleSubmit} title={"New Counter Party Contact Affiliation"}>
            <Form.Row style={{ padding: "0" }}>
              <Select
                label="Counter Party"
                name="funder"
                options={props.funderChoices.getChoices()}
                disabled={true}
                required={true}
              />
              <WSelect
                label="Counter Party Contact"
                name="funder_contact"
                options={props.funderContactChoices.getChoices()}
                placeholder="Select Account"
                required={true}
              />
            </Form.Row>
            <SubmitButton />
          </FormCollapsible>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => {
  const choices = managementChoicesSelector(state);
  return {
    activeFunderId: activeFunderIdSelector(state),
    funderChoices: choices.funders,
    funderContactChoices: choices.funder_contacts,
    shouldSave: shouldSaveSelector(state),
    hasAdminPermission: isAdmin(state),
  };
};

export default connect(mapStateToProps, {
  createFunderContactAffiliation,
  fetchFunderContactAffiliationsFromFunder,
})(BasicCreateContactAffiliationForm);
